import React from 'react';
import PropTypes from 'prop-types';

import styles from './index.styl';

const Marker = ({ value }) => (
  <div className={styles.root}>
    <div className={styles.markerValue}>{value}</div>
    <div className={styles.markerLine} />
  </div>
);

Marker.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default Marker;



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/PatientPortal/DataList/Card/LabTestResultCard/Marker/index.jsx